'use strict';

const jQuery = require('jquery');

const Container = require('./../../../../core/container');

const Translator = require('./../../../../core/translator');
const Loader = require('./../../../../services/loader');

const zoneBtntpl = require('./template/langbo.buttons.layer.hbs');
const popinBtntpl = require('./template/langbo.buttons.popin.hbs');

module.exports.init = function(items) {
    let currentLang = Translator.getLocale();
    let $tpl = jQuery(Container.get('isMobile') ? zoneBtntpl() : popinBtntpl());

    $tpl.find(`[data-lang="${currentLang || 'en'}"]`).addClass('active');

    $tpl.find('button.btn:not(.active)').on('click', function() {
        let $current = jQuery(this);
        let lang = $current.data('lang');

        $tpl.find('.active').removeClass('active');
        $current.addClass('active');

        Loader.start(Container.get('$smallPanel'));
        Translator.setLocale(lang);
        window.location.reload();
    });

    return $tpl;
};
